// this linting rule was flagging errors even after they had been addressed in various manners
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import './TensorFilter.css';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Modal from '../filterModal/FilterModal';

class TensorFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalShow: true,
      subString: '',
      title: '',
    };
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  closeModal() {
    this.setState({
      modalShow: false,
    });
    // console.log('modal');
  }

  openModal(e) {
    const title = e.target.innerHTML;
    const first3letters = title.substring(0, 3);
    this.setState({
      modalShow: true,
      subString: first3letters,
      title,
    });
  }

  render() {
    let modal;

    const refreshImg = (
      <img role="presentation"
        alt="refresh"
        src="closeLight.svg"
        className="resetIco"
      />
    );
    const {
      modalShow, title, subString,
    } = this.state;
    const {
      promoteOrRetrain, oemModels, handleChangeStart, handleChangeEnd, handleDropdownChange,
      makeSchedule, selectedStart, selectedEnd, softwareVersions,
    } = this.props;
    const filters = ['Date Range: ', 'OEM Model: ', 'Software Version: '];
    const createFilters = filters.map((filter) => {
      if (filter === 'Date Range: ') {
        return (
          <div key={filter}
            className="filter date-filter"
            role="presentation"
          >
            <span onClick={promoteOrRetrain !== 'promote' ? e => this.openModal(e) : null}>
              {`${filter} ${moment(selectedStart).format('MM/DD/YY')} - ${moment(selectedEnd).format('MM/DD/YY')}`}
            </span>
            {refreshImg}
          </div>
        );
      } if (filter === 'OEM Model: ') {
        const {
          schedulesPage, retrainModel, oemModel,
        } = this.props;
        return (
          <div key={filter}
            className={makeSchedule ? 'filter oem-filter no-border' : 'filter oem-filter'}
            role="presentation"
          >
            <span onClick={schedulesPage || retrainModel ? null : e => this.openModal(e)}>
              {filter}
              {' '}
              {oemModel}
            </span>
            {makeSchedule ? '' : refreshImg}
          </div>
        );
      } if (filter === 'Software Version: ') {
        const {
          schedulesPage, retrainModel, softwareVersion,
        } = this.props;
        return (
          <div key={filter}
            className={makeSchedule ? 'filter no-border' : 'filter'}
            role="presentation"
          >
            <span onClick={schedulesPage || retrainModel ? null : e => this.openModal(e)}>
              {filter}
              {' '}
              {softwareVersion}
            </span>
            {makeSchedule ? '' : refreshImg}
          </div>
        );
      }
      return filter;
    });
    // eslint-disable-next-line
    let fromInput;
    const dateRange = (
      <div>
        <div className="date-range-filter-form">
          <div>
            <label htmlFor="selectStartDate">
              {'From:'}
            </label>
            <input ref={(i) => { fromInput = i; }}
              disabled
              // onBlur={this.handleInputChangeStart}
              value={moment(selectedStart).format('MM/DD/YY')}
            />
            <DatePicker inline
              selected={selectedStart}
              selectsStart
              onChange={handleChangeStart}
              filterDate={date => moment() > date}
            />
          </div>
          <div>
            <label htmlFor="selectEndDate">
              {'To:'}
            </label>
            <input disabled
              value={moment(selectedEnd).format('MM/DD/YY')}
            />

            <DatePicker inline
              selected={selectedEnd}
              selectsEnd
              onChange={(date) => { handleChangeEnd(date); }}
              filterDate={date => moment() > date}
            />

          </div>

        </div>
        <div className="apply-btn">
          <button type="button"
            onClick={this.closeModal}
          >
            {'Apply'}
          </button>
        </div>
      </div>
    );
    let oem;
    if (oemModels) {
      oem = oemModels.map(model => (
        <option value={model}
          key={model}
        >
          {model}
        </option>
      ));
    }

    const oemModelsSection = (
      <div>
        <div className="oem-model">
          <p className="param-header">Select OEM Model</p>
          <select name="deviceModelType"
            id="deviceModelType"
            onChange={handleDropdownChange}
          >
            {oem}
          </select>
        </div>
        <div className="apply-btn">
          <button onClick={this.closeModal}
            type="button"
          >
            {'Apply'}
          </button>
        </div>
      </div>
    );
    let software;
    if (softwareVersions) {
      software = softwareVersions.map(version => (
        <option value={version}
          name="softwareVersion"
          key={version}
        >
          {version}
        </option>
      ));
    }

    const softwareVersionSection = (
      <div className="software-version">
        <p className="param-header">Select Software Version</p>
        <select name="softwareVersion"
          id="softwareVersion"
          onChange={handleDropdownChange}
        >
          {software}
        </select>
        <div className="apply-btn">
          <button onClick={this.closeModal}
            type="button"
          >
            {'Apply'}
          </button>
        </div>
      </div>
    );

    if (subString === 'Dat') {
      modal = (
        <Modal closeModal={this.closeModal}
          title={title}
          // children={dateRange}
        >
          {dateRange}
        </Modal>
      );
    } else if (subString === 'OEM') {
      modal = (
        <Modal closeModal={this.closeModal}
          title={title}
          // children={oemModelsSection}
        >
          {oemModelsSection}
        </Modal>

      );
    } else if (subString === 'Sof') {
      modal = (
        <Modal closeModal={this.closeModal}
          title={title}
          // children={softwareVersionSection}
        >
          {softwareVersionSection}
        </Modal>
      );
    }

    return (
      <div className="tensor-filter-panel">
        <div className="current-filters">
          {createFilters}
          {/* <span className="apply">
                        <a>Update Report</a>
                    </span> */}
        </div>

        <div className={modalShow ? 'show' : 'hide'}>
          {modal}
        </div>
      </div>
    );
  }
}

export default TensorFilter;
